import React, { useEffect, useState } from 'react';
import { always } from 'ramda';

export const Switch = (props) => {
  const { inputFields, hasError, onInputFieldChange } = props;

  const {
    onKeyDown = always,
    ariaLabelledby = '',
    role = 'checkbox',
    defaultValue = false,
    showCheckLabels = false,
    checkedLabel = 'On',
    uncheckedLabel = 'Off',
  } = inputFields;

  const [checked, setChecked] = useState(defaultValue);

  const onClickProxy = () => {
    const newState = !checked;
    setChecked(newState);
    onInputFieldChange(newState); 
  };

  const onKeyDownProxy = (e) => {
    switch (e.key) {
      case 'Enter': {
        const newState = !checked;
        setChecked(newState);
        onInputFieldChange(newState);
        onKeyDown(newState);
        break;
      }
      default: {
        break;
      }
    }
  };

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  return (
    <div
      role={role}
      aria-label={inputFields.ariaLabel || inputFields.title}
      aria-invalid={!!hasError}
      aria-describedby={hasError ? `${inputFields.id}_error` : ''}
      aria-checked={checked}
      aria-labelledby={ariaLabelledby}
      ref={inputFields.refInput}
      type={inputFields.type}
      disabled={inputFields.disabled}
      autoComplete={inputFields.autoComplete}
      value={inputFields.value}
      className={['switch', hasError && inputFields.required ? hasError : null].filter(v => !!v).join(' ')}
      id={inputFields.id}
      data-testid={inputFields.id}
      name={inputFields.name} 
      placeholder={inputFields.placeholder}
      onClick={onClickProxy}
      onKeyDown={onKeyDownProxy}
      tabIndex="0"
    >
      <span className="slider round"></span>
      <input type="checkbox" hidden/>
      <span className="label" hidden={!showCheckLabels}>
        {checked ? checkedLabel : uncheckedLabel}
      </span>
    </div>
  );
}

export default Switch;
